import progressProjectsReportComponent from './progress-projects-report.component';

const progressProjectsReportModule = angular.module('progressProjectsReport', [
])
  .component('progressProjectsReport', progressProjectsReportComponent)
  .name;

export default progressProjectsReportModule;
